import { useToast } from 'primevue/usetoast';

import { ref } from 'vue';

import { useNetworkStatus } from '../composables/useNetworkStatus';

import { calculationService } from '../utils/api/calculationService';
import { downloadJson } from '../utils/downloadJson';
import type { Calculation } from '../utils/types';

import { useCalculationsStore } from '../store/calculations';

export function useSaveCalculation() {
  const toast = useToast();

  const isLoading = ref(false);

  const { isOnline } = useNetworkStatus();

  const calculationStore = useCalculationsStore();

  async function saveCalculation(updatedCalculation: Calculation) {
    isLoading.value = true;

    if (isOnline.value) {
      try {
        const calculation = await calculationService.saveCalculation(updatedCalculation);

        calculationStore.saveCalculation(calculation);

        toast.add({
          severity: 'success',
          summary: 'Dodane kalkulacji zostały zaktualizowane',
          life: 3000,
        });
      } catch (error: any) {
        toast.add({
          severity: 'error',
          summary: 'Wystąpił błąd podczas zapisywania kalkulacji',
          life: 3000,
        });
      }
    } else {
      calculationStore.saveCalculation({ ...updatedCalculation, outdated: true });

      await downloadJson(
        updatedCalculation,
        `client_${updatedCalculation.name}_${updatedCalculation.uuid}`
      );

      toast.add({
        severity: 'warn',
        summary: 'Dodane kalkulacji zostały zaktualizowane w trybie offline',
        life: 3000,
      });
    }

    isLoading.value = false;
  }

  return { saveCalculation, isLoading };
}
